import { logWrapper } from '../utils';

function linkedFilesSortableDirectiveFactory(runtimeConstant) {
    function link(scope, element, attrs) {
        var draggedIndex = null;
        var container = element[0];

        function getRow(event) {
            var nativeEvent = event.originalEvent || event;
            var target = nativeEvent.target;

            if (!target || !target.closest) return null;

            var row = target.closest('tr[data-link-index]');

            return row && container.contains(row) ? row : null;
        }

        function updateDraggableRow(event) {
            var row = getRow(event);

            if (!row) return;

            row.draggable = row.getAttribute('data-is-main') !== 'true';
        }

        function onDragStart(event) {
            var row = getRow(event);

            if (!row || row.getAttribute('data-is-main') === 'true') {
                event.preventDefault();
                return;
            }

            draggedIndex = Number(row.getAttribute('data-link-index'));

            var nativeEvent = event.originalEvent || event;

            nativeEvent.dataTransfer.effectAllowed = 'move';
            nativeEvent.dataTransfer.setData('text/plain', String(draggedIndex));

            row.classList.add('dragging');
        }

        function onDragOver(event) {
            if (draggedIndex === null) return;

            event.preventDefault();

            var nativeEvent = event.originalEvent || event;
            nativeEvent.dataTransfer.dropEffect = 'move';
        }

        function onDrop(event) {
            event.preventDefault();

            var row = getRow(event);

            if (
                draggedIndex === null ||
                !row ||
                row.getAttribute('data-is-main') === 'true'
            ) {
                return;
            }

            var targetIndex = Number(row.getAttribute('data-link-index'));

            if (draggedIndex !== targetIndex) {
                scope.$apply(() => {
                    scope.$eval(attrs.linkedFilesSortable, {
                        fromIndex: draggedIndex,
                        toIndex: targetIndex,
                    });
                });
            }
        }

        function onDragEnd() {
            draggedIndex = null;

            container.querySelectorAll('.dragging').forEach((row) => {
                row.classList.remove('dragging');
            });
        }

        element.on('mouseover', updateDraggableRow);
        element.on('mousedown', updateDraggableRow);
        element.on('dragstart', onDragStart);
        element.on('dragover', onDragOver);
        element.on('drop', onDrop);
        element.on('dragend', onDragEnd);

        scope.$on('$destroy', () => {
            element.off('mouseover', updateDraggableRow);
            element.off('mousedown', updateDraggableRow);
            element.off('dragstart', onDragStart);
            element.off('dragover', onDragOver);
            element.off('drop', onDrop);
            element.off('dragend', onDragEnd);
        });
    }

    function run() {
        return {
            restrict: 'A',
            link,
        };
    }

    return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const linkedFilesSortableDirective = [
    'runtimeConstant',
    linkedFilesSortableDirectiveFactory,
];